/** Single entry returned by the endpoint; `trendRatio` drives the order (higher = more trending). */
export interface ITrendingGameEntry {
  gameKey: string;
  trendRatio: number;
}

export interface ITrendingGamesResponse {
  games: ITrendingGameEntry[];
}

const TRENDING_GAMES_PATH = '/api/history/statistics/trending-games';

const getTrendingGamesUrl = (host: string): string => `${host}${TRENDING_GAMES_PATH}`;

const EMPTY_RESPONSE: ITrendingGamesResponse = { games: [] };

export const fetchTrendingGames = async (apiHost: string): Promise<ITrendingGamesResponse> => {
  try {
    const response = await fetch(getTrendingGamesUrl(apiHost));

    if (!response.ok) {
      console.warn(`[TrendingAPI] Non-OK response (${response.status}) — section will be hidden`);
      return EMPTY_RESPONSE;
    }

    const data = (await response.json()) as Partial<ITrendingGamesResponse>;
    return { games: Array.isArray(data?.games) ? data.games : [] };
  } catch (error) {
    console.warn('[TrendingAPI] Failed to fetch trending games — section will be hidden:', error);
    return EMPTY_RESPONSE;
  }
};
